import { Pipe, PipeTransform, Inject, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Pipe({ name: 'linkToMap' })
export class LinkToMapPipe implements PipeTransform {
  document = inject(DOCUMENT);

  transform(address: string): string {
    if (!address) {
      return '';
    }

    const encoded = encodeURIComponent(address);
    const userAgent = this.document.defaultView?.navigator.userAgent || '';

    if (/Android/i.test(userAgent)) {
      return `geo:0,0?q=${encoded}`;
    }

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return `maps:?q=${encoded}`;
    }

    return `https://www.google.com/maps/search/?api=1&query=${encoded}`;
  }
}
